﻿import {withUppercase} from "../../../../hocs/withUppercase";
import {CardItemValue} from "../CardItemValue";

export const CardItemValueWithUppercase = withUppercase(CardItemValue);
